import './App.scss';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Main from "./screens/Main";
import Courses from "./screens/Courses";
import Course from "./screens/Course";
import Header from "./components/Header";

import { useSelector } from "react-redux";

function App() {
    const courseListState = useSelector(state => state.courseReducer.courseList);

    return (
        <>
            <Router>
                <Header />

                <div className='container mt-5'>
                    <Switch>

                        <Route exact path="/course/:id">
                            <Course />
                        </Route>
                        <Redirect from='/course' to='/courses' />
                        <Route exact path='/courses' component={Courses} />
                        <Route exact path='/' component={Main} />
                        <Redirect from='/' to='/' />
                        <Route path='*'>
                            <Main />
                        </Route>
                    </Switch>
                    <div className='w-100 d-flex flex-column flex-justify-end mb-3'>
                        {!courseListState &&
                            <span style={{ fontSize: '16px', textAlign: 'right', color: 'white', margin: '0 16px' }}>
                                Please set 'Insecure content' to 'Allow' for this web-page (as the eclass page is on HTTP).
                    <a href='https://stackoverflow.com/questions/18321032/how-to-get-chrome-to-allow-mixed-content' style={{ textDecoration: 'underline' }}>
                                    Click here for tutorial
                    </a>
                            </span>}
                        <span style={{ fontSize: '14px', color: 'white', textAlign: 'right', margin: '10px 16px' }}>Note: These assignments may not be the same as it is on your account,<br /> as the data is parsed from 1 account</span>
                    </div>
                </div>
            </Router>
        </>
    );
}

export default App;
